import React from 'react'
import EditAssetTypeCode from '../../components/assettypecodecomponents/EditAssetTypeCode'

function AssetTypeCodeEdit({ renderPageContent }) {
    return (
        <>

            {/*Dynamic content goes here */}
            <EditAssetTypeCode renderPageContent={renderPageContent} />


        </>
    )
}

export default AssetTypeCodeEdit;